import { LifeCycleStage } from '@repo/shared/dtos/organization'
import { Language, z } from '@repo/ui/lang'
import { zCleanString } from '@repo/ui/utils'

const urlSchema = z
  .string()
  .trim()
  .url()
  .refine((url) => url.startsWith('https://'), {
    message: 'URL must start with https://',
  })
  .refine((url) => url.includes('.'), {
    message: 'URL must include a domain',
  })
  .optional()

export const beneficiarySchema = {
  fullName: zCleanString.min(2).max(50),
  profile: z.object({
    value: zCleanString.min(10).max(10000),
  }),
}

export const taskCtaSchema = z
  .object({
    name: z.string().min(2).max(50),
    link: urlSchema,
  })
  .partial()
  .refine(
    (data) => {
      if ((data.name && !data.link) || (!data.name && data.link)) return false
      return true
    },
    { message: 'Both name and link are required if one is provided.' },
  )

export const taskSchema = z.object({
  categories: z.array(zCleanString.min(2).max(50)).optional(),
  content: zCleanString.min(10).max(1000),
  cta: taskCtaSchema.optional(),
  dueDate: z.number().optional(),
  title: zCleanString.min(2).max(250),
})

export const noteSchema = z.object({
  content: zCleanString.min(2).max(10000),
})

export const documentFileSchema = z.object({
  title: zCleanString.min(2).max(150),
})

export const emailSchema = zCleanString.email()
export const passwordSchema = zCleanString.min(12).max(100)
export const userPasswordSchema = {
  confirmPassword: passwordSchema,
  password: passwordSchema,
}

export const userSchema = {
  disabled: z.boolean(),
  email: emailSchema,
  firstName: zCleanString.min(2).max(50),
  lastName: zCleanString.min(2).max(50),
  organizationIds: z.array(zCleanString.uuid().min(36).max(36)).min(1),
  superAdmin: z.boolean(),
}

export const meSchema = {
  firstName: zCleanString.min(2).max(50),
  lastName: zCleanString.min(2).max(50),
}

export const promptSchema = z.string().max(500_000)

export const organizationSchema = {
  language: z.enum(Object.values(Language) as [Language]),
  description: promptSchema,
  name: zCleanString.min(2).max(50),
  lifeCycleStage: z.enum(Object.values(LifeCycleStage) as [LifeCycleStage]),
  url: urlSchema,
  assistantName: z.string().trim().max(50),
  answerGoal: z.string().trim().max(5_000).optional(),
  messageInstructions: z.string().trim().max(5_000).optional(),
  safetyRules: z.string().trim().max(5_000).optional(),
}

export const customValidationPasswords = (password: string, confirmPassword: string) => {
  const errors: Record<string, string> = {}
  if (password !== confirmPassword) {
    errors.confirmPassword = 'Passwords do not match.'
  }
  return errors
}
